export const REVIEW_CONDITIONS = [
    { label: 'Good', value: 'good' },
    { label: 'Poor', value: 'poor' },
    { label: 'Faulty', value: 'faulty' },
]